import { ClassificationItemListModel, ClassificationListModel } from "@/model/classification";

export function ConvertToClassificationList(data: Array<ClassificationListModel>) {
  const classificationList = new Array<ClassificationListModel>();
  if (data !== null) {
    for (const classification of data) {
      classificationList.push({
        id: classification.id,
        number: classification.number,
        name: classification.name,
        description: classification.description,
        allocationDocumentFinanceType: classification.allocationDocumentFinanceType,
        isArchived: classification.isArchived,
        isDeleted: classification.isDeleted,
      });
    }
    return classificationList;
  }
}
export function ConvertToClassificationItemList(data: Array<ClassificationItemListModel>) {
  const classificationItems = new Array<ClassificationItemListModel>();
  if (data !== null) {
    for (const classificationItem of data) {
      classificationItems.push({
        id: classificationItem.id,
        allocationId: classificationItem.allocationId,
        number: classificationItem.number,
        name: classificationItem.name,
        description: classificationItem.description,
        color: classificationItem.color,
        iconType: classificationItem.iconType,
        isArchived: classificationItem.isArchived,
        isDeleted: classificationItem.isDeleted,
      });
    }
    return classificationItems;
  }
}
